﻿import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type AdminCalendarTabProps = {
    label: string;
    route: string;
};

const CalendarsRoute = '/calendars';

let routes = [CalendarsRoute];

function AdminCalendarTab({ route, label, ...props }: AdminCalendarTabProps) {
    function handleClick() {
        history.push(CalendarsRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={CalendarsRoute} />;
}

function TranslatedAdminCalendarTab(props) {
    const label = Translate('header/nav/calendars');

    return <AdminCalendarTab {...props} label={label} />;
}

TranslatedAdminCalendarTab.routes = routes;

export default TranslatedAdminCalendarTab;
